import React, { useRef } from "react";
import Chart from "react-apexcharts";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { appLogger } from "../../../utils";
import { chartHighlighter } from "../../../utils/common/chartHighlighter";

interface chartData {
  total: number;
  avg: number;
  data: Object;
}
interface categoryChartProps {
  categoryChartData: chartData;
  setChartData: any;
  chartShow: any;
  filter: any;
  selected: any;
}

const TicketStatusChart = (props: categoryChartProps) => {
  const ref = useRef<HTMLElement>(null);
  const { categoryChartData, chartShow, filter, selected } = props;
  appLogger.info({
    infoObj: {
      method: "TicketStatusChart",
      component: "feedback",
      fileName: "category.tsx",
      props: props,
    },
  });
  const seriesValue: number[] = Object.values(categoryChartData.data);
  const statusSortedArray: string[] = Object.keys(categoryChartData.data);
  const labelValue = statusSortedArray.map(
    (status) => status.charAt(0).toUpperCase() + status.slice(1)
  );
  // const statusSortedArray = getStatuses.sort();
  const colorArray: any[] = [];
  const colorObject: any = {
    closed: "#838DA9",
    inprogress: "#2DC272",
    new: "#E29522",
    open: "#0096FF",
    "pending response": "#0098FF",
    replied: "#E29512",
    unknown: "#838DA4",
  };

  statusSortedArray &&
    statusSortedArray.length > 0 &&
    statusSortedArray.map((d: any) => {
      colorArray.push(colorObject[d]);
    });

  // console.log(statusSortedArray, "statusSortedArray");

  // if (statusSortedArray && statusSortedArray.length > 0) {
  //   if (statusSortedArray.includes("closed")) {
  //     colorArray.push("#838DA9");
  //   }
  //   if (statusSortedArray.includes("inprogress")) {
  //     colorArray.push("#2DC272");
  //   }
  //   if (statusSortedArray.includes("new")) {
  //     colorArray.push("#E29522");
  //   }
  // }
  const options = {
    chart: {
      toolbar: {
        show: true,
        tools: {
          download: true,
        },
        export: {
          csv: {
            filename: "CuVo_Category",
          },
          svg: {
            filename: "CuVo_Category",
          },
          png: {
            filename: "CuVo_Category",
          },
        },
      },

      // selection: {
      //   enabled: false,
      // },

      // events: {
      //   dataPointSelection: function (
      //     event: any,
      //     chartContext: any,
      //     config: any
      //   ) {
      //     // click: function (event: any, chartContext: any, config: any) {

      //     const selectedDataPoints: number[] = config.selectedDataPoints[0];

      //     chartHighlighter(selectedDataPoints, ref.current, "pie");

      //     const modifiedArr =
      //       selectedDataPoints?.length > 0
      //         ? [chartContext.w.config.labels[selectedDataPoints[0]]]
      //         : [];

      //     // const k = selectedDataPoints.forEach((e: any) => {
      //     //   if (e == 0) {
      //     //     e = 5;
      //     //   } else if (e == 1) {
      //     //     e = 4;
      //     //   } else if (e == 2) {
      //     //     e = 3;
      //     //   } else if (e == 3) {
      //     //     e = 2;
      //     //   } else if (e == 4) {
      //     //     e = 1;
      //     //   }
      //     // });

      //     // const selectedFilterLabel = config.w.globals.labels;
      //     // const selectedFilterValue =
      //     //   config.w.config.series[0].data[dataPointIndexValue];
      //     appLogger.info({
      //       infoObj: {
      //         method: "dataPointSelection",
      //         component: "feedback",
      //         fileName: "category.tsx",
      //         config: config,
      //       },
      //     });
      //     const dataPointIndexValue = config.dataPointIndex;
      //     const selectedFilterLabel =
      //       config.w.globals.labels[dataPointIndexValue];
      //     const selectedFilterValue =
      //       config.w.config.series[dataPointIndexValue];
      //     appLogger.info({
      //       infoObj: {
      //         method: "dataPointSelection",
      //         component: "feedback",
      //         fileName: "category.tsx",
      //         data: { selectedFilterLabel, selectedFilterValue },
      //       },
      //     });
      //     const test = {
      //       // name: "",
      //       // filters: [
      //       // {
      //       field: "CATEGORY",
      //       operation: "contains",
      //       value: modifiedArr,
      //       // },
      //       // ],
      //       // advanceFilters: [],
      //     };

      //     props.setChartData(test);
      //   },
      //   updated: function (config: any) {
      //     if (filter && filter.filters) {
      //       const modifiedFilter = filter?.filters?.find(
      //         (data: any) => data.field === "CATEGORY"
      //       )
      //         ? filter?.filters?.find((data: any) => data.field === "CATEGORY")
      //             .value
      //         : "";

      //       config.w.globals.selectedDataPoints[0] =
      //         filter?.filters?.length === 1 && !selected ? modifiedFilter : [];
      //     }
      //   },
      //   mounted: function (config: any) {
      //     const modifiedFilter = filter?.filters?.find(
      //       (data: any) => data.field === "CATEGORY"
      //     )?.value;

      //     config.w.globals.selectedDataPoints[0] =
      //       filter?.filters?.length === 1 && !selected ? modifiedFilter : [];
      //   },
      // },
    },

    // states: {
    //   active: {
    //     allowMultipleDataPointsSelection: false,
    //   },
    // },

    series: seriesValue?.length > 0 ? seriesValue : [0],
    labels: labelValue,
    colors: colorArray,
    // colors: [
    //   "#b9bd53",
    //   "#83870c",
    //   "#48a89d",
    //   "#017a6d",
    //   "#003e5c",
    //   "#6480cc",
    //   "#6c68d9",
    //   "#110c94",
    //   "#25016e",
    //   "#b24dd6",
    //   "#86ab46",
    //   "#4e7a01",
    //   "#19668c",
    //   "#0299e3",
    //   "#164de0",
    //   "#1c3373",
    //   "#8a5ae8",
    //   "#5a1ad9",
    //   "#75029e",
    //   "#cc35a9",
    // ],
    plotOptions: {
      pie: {
        donut: {
          size: "40%",
        },
        expandOnClick: false,
      },
    },
  };

  return (
    <>
      {chartShow && (
        <>
          {categoryChartData && categoryChartData.total > 0 && (
            <Box
              ref={ref}
              className="rating-chart-wrap"
              sx={{
                height: "318px !important",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Chart
                options={options}
                series={options.series as []}
                width={350}
                height={250}
                type="donut"
              />
            </Box>
          )}

          {categoryChartData && categoryChartData.total < 1 && (
            <Typography className="no-data">no data</Typography>
          )}
        </>
      )}
    </>
  );
};

export default TicketStatusChart;
